export class TipoDocumentoCliente {
  id: number;
  descricao: string;
}
